import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import cls from './safe.module.scss';
import { Icon, Button } from 'lb-components';
import { BigSafeIcon } from '../../../../assets/icons/menu';
import { Api, Toast, useTranslation } from 'lb-store';
import { UseOTP, UseUser } from 'lb-store/src/hooks';

const Safe = ({ t }) => {
  const [safeBalance, setSafeBalance] = useState();
  const [safeAction, setSafeAction] = useState();
  const formRef = useRef();

  useEffect(() => {
    getSafeBalance();
  }, []);
  const otp = UseOTP();
  const { updateBalance } = UseUser();

  const getSafeBalance = () => {
    Api.User.Safe.balance().then((res) => {
      if (res.status && res.data?.status === 1)
        setSafeBalance(res.data.balance);
    });
  };

  const balanceSmsHandler = () => {
    Api.User.Safe.balanceToSms().then((res) => {
      if (res.status && res.data.desc) {
        Toast.show({
          type: res.data?.res ? 'success' : 'error',
          content: res.data?.res
            ? t('ინფორმაცია გამოიგზავნა თქვენს ნომერზე')
            : res.data.desc,
        });
      }
    });
  };
  const openSafeHandler = () => {
    Api.User.Safe.open({}).then((res) => {
      if (/*res.status*/ true) {
        otp.open({
          onSuccess: (code, callback, close) => {
            Api.User.Safe.open({ smsCode: code }).then((res) => {
              if (res.status) {
                close();
                //fetch updated safe data
                Api.User.Safe.balance().then((res) => {
                  if (res.status && res.data?.status)
                    setSafeBalance(res.data?.balance);
                });
              } else {
                //callback(res.data?.error);
                callback(t('შეცდომა! შეიყვანეთ სწორი SMS კოდი'));
              }
            });
          },
          onResend: (callback) => {
            Api.User.Safe.open({}).then((res) => {
              callback(res.data?.left, res.data?.desc);
            });
          },
        });
      }
    });
  };
  const safeActionHandler = (e) => {
    e.preventDefault();

    let from, to;
    if (safeAction === 'deposit') {
      from = 1;
      to = 104;
    } else if (safeAction === 'withdraw') {
      from = 104;
      to = 1;
    }

    Api.User.Safe.transfer({
      from,
      to,
      money: parseFloat(e.target.amount.value),
    }).then((res) => {
      if (res.status && res.data?.status === 1) {
        Toast.show({
          type: 'success',
          content: t('თანხა წარმატებით გადაირიცხა'),
        });
        setSafeAction(null);
        updateBalance(true).finally();
        getSafeBalance();
      } else {
        Toast.show({ type: 'error', content: res.data?.desc });
      }
    });
  };
  return (
    <div className={cls.safePage}>
      {safeBalance ? (
        <div className={cls.manage}>
          <div className={cls.balance}>
            <span>
              {safeBalance}
              <sup>₾</sup>
            </span>
            <br />
            <label>{t('სეიფში არსებული თანხა')}</label>
          </div>
          <div className={cls.actions}>
            <div>
              <Button
                variant={'success'}
                style={{ marginRight: '1.8rem' }}
                onClick={() => {
                  formRef.current?.reset();
                  setSafeAction('deposit');
                }}
              >
                {t('თანხის შეტანა')}
              </Button>
              <Button
                variant={'info'}
                onClick={() => {
                  formRef.current?.reset();
                  setSafeAction('withdraw');
                }}
              >
                {t('თანხის გატანა')}
              </Button>
            </div>
            {safeAction ? (
              <div className={cls.actionContainer}>
                <label>
                  {safeAction === 'deposit'
                    ? t('სეიფში თანხის გადარიცხვა')
                    : t('სეიფიდან თანხის გადმორიცხვა')}
                </label>
                <Form
                  noValidate
                  onSubmit={safeActionHandler}
                  ref={formRef}
                  className={cls.form}
                >
                  <Form.Control
                    name={'amount'}
                    type={'number'}
                    placeholder={'შეიყვანე თანხა'}
                  />
                  <Button type={'submit'}>{t('გადარიცხვა')}</Button>
                </Form>
                <Button
                  variant={'danger'}
                  style={{ marginTop: '1.8rem' }}
                  onClick={() => setSafeAction(null)}
                >
                  {t('გამოსვლა')}
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  variant={'danger'}
                  onClick={() => {
                    Api.User.Safe.close().then((res) => {
                      if (res.status) setSafeBalance(null);
                    });
                  }}
                >
                  {t('სეიფის დახურვა' + '' + '' + '')}
                </Button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={cls.content}>
          <Icon Icon={BigSafeIcon} width={'15rem'} height={'15rem'} />
          <h3 className={cls.title}>{t('სეიფის მართვა')}</h3>
          <p className={cls.description}>
            {t(
              'სეიფის მართვის ახალი სერვისი გააკონტროლეთ, დაიცავით და შეინახეთ თქვენი თანხა!'
            )}
          </p>
          <Button
            variant={'outline-info'}
            className={cls.button}
            onClick={balanceSmsHandler}
          >
            {t('ბალანსის შემოწმება')}
          </Button>
          <Button
            variant={'secondary'}
            className={cls.buttonOpen}
            onClick={openSafeHandler}
          >
            {t('სეიფის გახსნა')}
          </Button>
        </div>
      )}
    </div>
  );
};
export default Safe;
